import React, { useState } from "react";

function NewsletterForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Subscribed!");
    setName("");
    setEmail("");
    // Send data to webhook, but don't check response
    fetch("https://metanovaai.app.n8n.cloud/webhook/23f46c2f-056e-43ff-bba5-ce90e95dfb56", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email }),
    });
  };

  return (
    <div className="w-full max-w-md">
      <div className="bg-blue-900/10 rounded-lg p-6">
        <h3 className="text-lg font-semibold mb-2 text-white">Stay Updated with ZettAI Insights</h3>
        <p className="text-sm text-blue-200 mb-4">Get the latest updates on AI-powered analytics and business intelligence straight to your inbox.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col gap-2">
            <div className="relative">
              <input
                type="text"
                id="newsletter-name"
                name="name"
                placeholder="Your Name"
                value={name}
                onChange={e => setName(e.target.value)}
                required
                autoComplete="name"
                className="w-full bg-transparent border-2 border-blue-400 text-white placeholder-gray-400 focus:outline-none focus:border-blue-300 focus:ring-0 transition-all duration-200 text-sm font-medium px-4 py-2 rounded-lg"
              />
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-400 transition-all duration-300" style={{
                transform: name ? 'translateX(0%)' : 'translateX(-100%)',
                opacity: name ? 1 : 0
              }}></div>
            </div>
            <div className="relative">
              <input
                type="email"
                id="newsletter-email"
                name="email"
                placeholder="Your Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full bg-transparent border-2 border-blue-400 text-white placeholder-gray-400 focus:outline-none focus:border-blue-300 focus:ring-0 transition-all duration-200 text-sm font-medium px-4 py-2 rounded-lg"
              />
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-400 transition-all duration-300" style={{
                transform: email ? 'translateX(0%)' : 'translateX(-100%)',
                opacity: email ? 1 : 0
              }}></div>
            </div>
          </div>
          <button type="submit" className="bg-blue-400 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-blue-500 transition-colors">
            Subscribe
          </button>
          {status && <div className="text-sm text-blue-200 mt-2">{status}</div>}
        </form>
      </div>
    </div>
  );
}

export default NewsletterForm;
